import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RoutesFun } from '../../schemas/index';
import {
  ProtectedRoute,
  ProtectedRouteProps,
} from '../AuthenticatedRoute/AuthenticatedRoute';
import { Grid } from '@material-ui/core';
import { authService } from '../../services';
import { DashboardHeader } from '../Header/DashboardHeader';
import { Navigation } from '../Navigation/Navigation';
import IdleInstance from '../../pages/IdleInstances/IdleInstances';
import CostForecasting from '../../pages/CostForecasting/CostForecasting';
import RightSizing from '../../pages/RightSizing/RightSizing';
import CostSaving from '../../pages/CostSaving/CostSaving';
// import Inventories from '../../pages/Inventories/Inventories';
// import Inventory from '../../pages/Inventories/Inventory';
import { ScheduleVM } from '../../pages/ScheduleVM/ScheduleVM';
import { SpendingDetails } from '../../pages/CostForecasting/SpendingDetails/SpendingDetails';
import { ServiceWiseSpendingDetails } from '../../pages/CostForecasting/ServiceWiseSpendingDetails/ServiceWiseSpendingDetails';
import { UsersList } from '../../pages';
import { Invoice } from '../../pages/Invoice/Invoice';
import TagBillingDetail from '../../pages/TagBillingDetail/TagBillingDetail';
import SecurityScan from '../../pages/SecurityScan/SecurityScan';
import { InventoryReport } from '../../pages/Reports/InventoryReport';
import AppDashboard from '../../pages/AppDashboard/AppDashboard';
import NotificationManagement from '../../pages/NotificationManagement/NotificationManagement';
// import UptimeMonitoring from '../../pages/UptimeMonitoring/UptimeMonitoring';
import Billing from '../../pages/Billing/Billing';
import AdminDashboard from '../../superAdmin/pages/AdminDashboard/AdminDashboard';
import OrganizationDetails from '../../superAdmin/pages/OrganizationDetails/OrganizationDetails';
import AllOrganizations from '../../superAdmin/pages/AllOrganizations/AllOrganizations';
import SubAdmins from '../../superAdmin/pages/SubAdmins/SubAdmins';
import DocumentUpload from '../../superAdmin/pages/DocumentUpload/DocumentUpload';
import UploadedDocuments from '../../pages/UploadedDocuments/UploadedDocuments';
import AdminPanelBilling from '../../superAdmin/pages/Billing/Billing';
import IdleResourcesTable from '../../pages/IdleInstances/IdleResourcesTable';
import OrgBillingDetails from '../../superAdmin/pages/Billing/OrgBillingDetails';
import PlanDetails from '../../pages/Billing/PlanDetails';
import TrialPlanConfirmation from '../../pages/TrialPlanConfirmation/TrialPlanConfirmation';
import ServicesReports from '../../pages/ServicesReports/ServicesReports';
import HighestConsumedResources from '../../pages/HighestConsumedResources/HighestConsumedResources';
import SystemHealth from '../../superAdmin/pages/SystemHealth/SystemHealth';
import RightsizingAndIdleInput from '../../pages/RightsizingAndIdleInput/RightsizingAndIdleInput';
import URLMonitoring from '../../pages/UptimeMonitoring/URLMonitoring';
import RUMDashboard from '../../pages/RUM/Dashboard';
// import HealthMonitoringDashboard from '../../pages/HealthMonitoring/Dashboard';
import RUMDescription from '../../pages/RUM/Description';
import AddServerHealthVisualizationPage from '../../pages/HealthMonitoring/AddServerHealthVisualizationPage';
import { useSelector } from 'react-redux';
import { uiState, userState } from '../../store';
import AwsAccountOnboarding from '../../pages/Accounts/CreateAccount/ManualSections/ManualOnboarding';
import AutomatedCard from '../../pages/Accounts/CreateAccount/AutomatedCard';
import CostAnalysis from '../../pages/CostAnalysis/CostAnalysis';
import DataTransfer from '../../pages/CostBreakup/DataTransfer/DataTransfer';
import Database from '../../pages/CostBreakup/Database';
import InstanceCost from '../../pages/CostBreakup/InstanceCost';
import Containers from '../../pages/CostBreakup/Containers';
import Storage from '../../pages/CostBreakup/Storage';
import Cloudwatch from '../../pages/CostBreakup/Cloudwatch';
import NetworkContentDelivery from '../../pages/CostBreakup/NetworkContentDelivery';
import SecurityCostBreakup from '../../pages/CostBreakup/SecurityCostBreakup';
import Serverless from '../../pages/CostBreakup/Serverless';
import Analytics from '../../pages/CostBreakup/Analytics';
import MigrationTransfer from '../../pages/CostBreakup/MigrationTransfer';
import MediaServices from '../../pages/CostBreakup/MediaServices';
import BillingConsole from '../../pages/BillingConsole/BillingConsole';
import ServicesCost from '../../pages/Inventories/ServicesCost';
import ServiceCostDetail from '../../pages/Inventories/ServiceCostDetail';
import ComparisonReports from '../../pages/ComparisonReports/ComparisonReports';
import CustomSnackBar from '../MasterComponent/CustomSnackbar/CustomSnackBar';
import AccountWiseBreakup from '../../pages/AccountWiseBreakup/AccountWiseBreakup';
import Coverage from '../../pages/Reservations/Coverage';
import Summary from '../../pages/Reservations/Summary';
import ManagePlan from '../../superAdmin/pages/ManagePlans/ManagePlan';
import { OperationLogTable } from '../ReportTable/OperationLogTable';

export const Dashboard: React.FC = () => {
  const Routes = RoutesFun();
  const userData = useSelector(userState);
  const user: any = userData.userData;
  const { collapsed } = useSelector(uiState);
  const [nChange, setnChange] = React.useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const defaultProtectedRouteProps: ProtectedRouteProps = {
    isAuthenticated: authService.checkAuth(),
    authenticationPath: '/login',
  };

  const subscriptionMessage =
    user?.RemainingDays <= 30
      ? `Your subscription expires in ${user.RemainingDays} day${
          user.RemainingDays !== 1 ? 's' : ''
        }!`
      : '';

  return (
    <React.Fragment>
      <DashboardHeader changeStatus={setnChange} />
      {user?.RoleId !== 1 && user?.RemainingDays !== null && (
        <CustomSnackBar
          message={subscriptionMessage}
          severity="warning"
          onClose={handleClose}
          open={open}
        />
      )}

      <Grid container spacing={0} className="mt-0">
        <Grid className="innerContainer">
          <div className="splitLayout">
            <div className={`leftNav ${collapsed ? 'collapsed' : ''}`}>
              <Navigation />
            </div>
            <div className="rightContent">
              <div className="innerRightContent">
                <Switch>
                  <Route
                    exact
                    path={Routes.CostForecasting}
                    component={CostForecasting}
                  />
                  <Route exact path={Routes.UsersList} component={UsersList} />
                  <Route
                    exact
                    path={Routes.CreateManualAccount}
                    component={AwsAccountOnboarding}
                  />
                  <Route
                    exact
                    path={Routes.CreateAutomationAccount}
                    component={AutomatedCard}
                  />
                  <Route
                    exact
                    path={[
                      Routes.IdleInstance,
                      Routes.IdleInstancewithType,
                      Routes.IdleInstancewithResName,
                    ]}
                    component={IdleInstance}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.IdleInstanceDetail}
                    component={IdleResourcesTable}
                  />
                  <ProtectedRoute
                    {...defaultProtectedRouteProps}
                    exact={true}
                    path={[Routes.RightSizing, Routes.RightSizingwithType]}
                    component={(props: any) => (
                      <RightSizing {...props} nState={nChange} />
                    )}
                  />
                  <Route
                    exact
                    path={Routes.CostSaving}
                    component={CostSaving}
                  />
                  {/* <Route
                    exact
                    path={Routes.Inventories}
                    component={Inventories}
                  /> */}
                  <Route
                    exact
                    path={Routes.ServicesCost}
                    component={ServicesCost}
                  />
                  {/* <Route
                    exact
                    path={Routes.InventoryDetail}
                    component={Inventory}
                  /> */}
                  <Route
                    exact
                    path={Routes.ServiceCostDetail}
                    component={ServiceCostDetail}
                  />
                  <Route
                    exact
                    path={Routes.ScheduleVM}
                    component={ScheduleVM}
                  />
                  <Route exact path={Routes.Invoice} component={Invoice} />
                  <Route
                    exact
                    path={Routes.TagDetailWithValue}
                    component={TagBillingDetail}
                  />
                  <Route
                    exact
                    path={Routes.SpendingDetails}
                    component={SpendingDetails}
                  />
                  <Route
                    exact
                    path={Routes.ServiceWiseSpendingDetails}
                    component={ServiceWiseSpendingDetails}
                  />
                  <Route
                    exact
                    path={Routes.SecurityScan}
                    component={SecurityScan}
                  />
                  <Route
                    exact
                    path={Routes.InventoryReports}
                    component={InventoryReport}
                  />
                  <Route
                    exact
                    path={Routes.ServicesReports}
                    component={ServicesReports}
                  />
                  <Route
                    exact
                    path={Routes.ComparisonReports}
                    component={ComparisonReports}
                  />
                  <Route
                    exact
                    path={Routes.CostAnalysis}
                    component={CostAnalysis}
                  />
                  <Route
                    exact
                    path={Routes.BillingConsole}
                    component={BillingConsole}
                  />{' '}
                  <Route
                    exact
                    path={Routes.DataTransfer}
                    component={DataTransfer}
                  />
                  <Route exact path={Routes.Database} component={Database} />
                  <Route
                    exact
                    path={Routes.InstanceCost}
                    component={InstanceCost}
                  />
                  <Route
                    exact
                    path={Routes.Containers}
                    component={Containers}
                  />
                  <Route exact path={Routes.Storage} component={Storage} />
                  <Route
                    exact
                    path={Routes.Cloudwatch}
                    component={Cloudwatch}
                  />
                  <Route
                    exact
                    path={Routes.NetworkContentDelivery}
                    component={NetworkContentDelivery}
                  />
                  <Route
                    exact
                    path={Routes.SecurityCostBreakup}
                    component={SecurityCostBreakup}
                  />
                  <Route
                    exact
                    path={Routes.Serverless}
                    component={Serverless}
                  />
                  <Route exact path={Routes.Analytics} component={Analytics} />
                  <Route
                    exact
                    path={Routes.MigrationTransfer}
                    component={MigrationTransfer}
                  />
                  <Route
                    exact
                    path={Routes.MediaServices}
                    component={MediaServices}
                  />
                  {/* Reservations */}
                  <Route exact path={Routes.Coverage} component={Coverage} />
                  <Route exact path={Routes.Summary} component={Summary} />
                  <Route
                    exact
                    path={Routes.AccountWiseBreakup}
                    component={AccountWiseBreakup}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.AppDashboard}
                    component={AppDashboard}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.NotificationManagement}
                    component={NotificationManagement}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.RightsizingAndIdle}
                    component={RightsizingAndIdleInput}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.Billing}
                    component={Billing}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.OperationLog}
                    component={OperationLogTable}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.PlanDetails}
                    component={PlanDetails}
                  />
                  <ProtectedRoute
                    exact
                    path={[
                      Routes.UptimeMonitoring,
                      Routes.UptimeMonitoringWithType,
                    ]}
                    // component={UptimeMonitoring}
                    component={URLMonitoring}
                  />
                  <ProtectedRoute
                    exact
                    path={[Routes.RealUserMonitoring]}
                    component={RUMDashboard}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.SystemHealthMonitoring}
                    component={AddServerHealthVisualizationPage}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.RUMDescription}
                    component={RUMDescription}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.TrialPlanConfirmation}
                    component={TrialPlanConfirmation}
                  />
                  <Route
                    exact
                    path={Routes.UploadedDocuments}
                    component={UploadedDocuments}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.HighestConsumedResource}
                    component={HighestConsumedResources}
                  />
                  {/* admin panel */}
                  <ProtectedRoute
                    exact
                    path={Routes.AdminDashboard}
                    component={AdminDashboard}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.Organization}
                    component={OrganizationDetails}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.AllOrganizations}
                    component={AllOrganizations}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.SubAdmins}
                    component={SubAdmins}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.DocumentUpload}
                    component={DocumentUpload}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.AdminPanelBilling}
                    component={AdminPanelBilling}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.AdminPanelOrganizationBillingDetails}
                    component={OrgBillingDetails}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.SystemHealth}
                    component={SystemHealth}
                  />
                  <ProtectedRoute
                    exact
                    path={Routes.ManagePlan}
                    component={ManagePlan}
                  />

                  <Redirect to={Routes.Inventories} />
                </Switch>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
